import CoachTaskAdminContext from './CoachTaskAdminContext';

export default CoachTaskAdminContext;
export * from './withCoachTaskAdminContext';
